import { render } from "./MessageAdminPage.vue?vue&type=template&id=1ddd6262"
import script from "./MessageAdminPage.vue?vue&type=script&lang=js"
export * from "./MessageAdminPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__